import React, { Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      <Link color="inherit" href="https://twitter.com/glauber_holanda">@glauber_holanda</Link>{' '}
    </Typography>
  );
}

const useStyles = makeStyles(theme => ({
  footer: {
    padding: theme.spacing(6),
  },
}));

function Footer() {
  const classes = useStyles();

  return (
    <Fragment>
      <CssBaseline />
      <footer className={classes.footer}>
        <Typography variant="h6" align="center" gutterBottom>Data Hodor!</Typography>
        <Copyright />
      </footer>
    </Fragment>
  );
}

export default Footer;